import React, { LegacyRef, useContext } from "react";
import AppInfoContext from "src/provider/state-manager/appInfoProvider";
import { AppLink, AppSpan, AppText, CustomContainer, FlexColumn, FlexRow, GridContainer, Icon } from "src/style";
import { AiOutlineInstagram, AiOutlineTwitter } from "react-icons/ai";
import { ImFacebook } from "react-icons/im";
import { moneyFormat } from "src/utils/utility";
import { ToWords } from 'to-words';
import helpers from "src/utils/helpers";
//https://e.hypermatic.com/41f617d46261778d4f9c90b28686d27e.png

export const ReceiptView = React.forwardRef(({data}: any, ref: LegacyRef<HTMLDivElement> | undefined) => {
    const {info: {institutionData}} = useContext(AppInfoContext)
    
    //let date: any = data?.transactionDate ? helpers.splitDateTime(data?.transactionDate) : '00/00/00'
    const toWords = new ToWords({
        localeCode: 'en-NG',
        converterOptions: {
          currency: true,
          ignoreDecimal: false,
          ignoreZeroCurrency: false,
          doNotAddOnly: true,
          currencyOptions: {
            name: 'Naira',
            plural: 'Naira',
            symbol: 'NGN',
            fractionalUnit: {
              name: 'Kobo',
              plural: 'Kobo',
              symbol: '',
            },
          }
        }
    });

    function convertAmounToWords (amount: string|number) {
        if (typeof amount === 'string') {
            amount = amount.replace(/,/g, '')
            amount = Number(amount)
        }

        return toWords.convert(amount)
    }

    
    return (
        <div ref={ref} style={{width: '100%', height: "100%", backgroundColor: '#ffffff'}}>
            <CustomContainer minHeight='100' mnHUnit="%">
                <GridContainer height="8" bgColor="#eeeeee">
                    <FlexRow width="auto" sizeUnit="" gap='2'>
                        <AppLink target="_blank" color="#777777" fontWeight="500" textSize="2.2">View in the browser</AppLink>
                        {/* <AppLink target="_blank" color="#777777" fontWeight="500" textSize="2.2">Unsubscribe</AppLink> */}
                    </FlexRow>
                </GridContainer>
                <GridContainer bgColor="#1A2C37" height="11">
                    <CustomContainer width="90" sizeUnit="%">
                        <CustomContainer width='15.4' height='4'>
                            {institutionData?.logo ? <Icon src={institutionData?.logo} /> : null}
                        </CustomContainer>
                    </CustomContainer>
                </GridContainer>
                <GridContainer bgColor="#0D968F" height="10">
                    <CustomContainer width="90" sizeUnit="%">
                        <AppText textSize="3" fontWeight="700" color="#ffffff" fontFamily="Gilmer-Bold">Transaction Receipt</AppText>
                    </CustomContainer>
                </GridContainer>
                <GridContainer>
                    <CustomContainer width="90" sizeUnit="%" topMargin="2.5">
                        <FlexRow justifyContent="space-between" gap="2" topMargin="2.5">
                            <AppText textSize="2.5" fontWeight="700">Transaction Reference</AppText>
                            <AppText textSize="2.5">{data?.transactionReference}</AppText>
                        </FlexRow>
                        <FlexRow justifyContent="space-between" gap="2" topMargin="2.5">
                            <AppText textSize="2.5" fontWeight="700">Transaction Type</AppText>
                            <AppText textSize="2.5">{data?.transactionType || (data?.transferType != '2' ? 'Intra-bank Transfer' : 'Inter-bank Transfer')}</AppText>
                        </FlexRow>
                        <FlexRow justifyContent="space-between" gap="2" topMargin="2.5">
                            <AppText textSize="2.5" fontWeight="700">Sender</AppText>
                            <AppText textSize="2.5">{data?.senderAccountName}</AppText>
                        </FlexRow>
                        <FlexRow justifyContent="space-between" gap="2" topMargin="2.5">
                            <AppText textSize="2.5" fontWeight="700">Beneficiary Bank</AppText>
                            <AppText textSize="2.5">{data?.recipientBankName}</AppText>
                        </FlexRow>
                        <FlexRow justifyContent="space-between" gap="2" topMargin="2.5">
                            <AppText textSize="2.5" fontWeight="700">Beneficiary Name</AppText>
                            <AppText textSize="2.5">{data?.recipientAccountName}</AppText>
                        </FlexRow>
                        <FlexRow justifyContent="space-between" gap="2" topMargin="2.5">
                            <AppText textSize="2.5" fontWeight="700">Beneficiary Account Number</AppText>
                            <AppText textSize="2.5">{data?.recipientAccountNumber}</AppText>
                        </FlexRow>
                        <FlexRow justifyContent="space-between" gap="2" topMargin="2.5">
                            <AppText textSize="2.5" fontWeight="700">Transaction Amount</AppText>
                            <AppText textSize="2.5">{moneyFormat(data?.amount || 0, true,institutionData?.defaultCurrency)}</AppText>
                        </FlexRow>
                        <FlexRow justifyContent="space-between" gap="2" topMargin="2.5">
                            <AppText textSize="2.5" fontWeight="700">Amount in Words</AppText>
                            <AppText textSize="2.5">{data?.amount ? convertAmounToWords(data?.amount) : ''}</AppText>
                        </FlexRow>
                        <FlexRow justifyContent="space-between" gap="2" topMargin="2.5">
                            <AppText textSize="2.5" fontWeight="700">Transaction Date</AppText>
                            <AppText textSize="2.5">{data?.transactionDate}</AppText>
                        </FlexRow>
                        <FlexRow justifyContent="space-between" gap="2" topMargin="2.5">
                            <AppText textSize="2.5" fontWeight="700">Narration</AppText>
                            <AppText textSize="2.5">{data?.narration}</AppText>
                        </FlexRow>
                    </CustomContainer>
                </GridContainer>
                <GridContainer topMargin="7" bgColor="#eeeeee" minHeight="18">
                    <CustomContainer width="auto" sizeUnit="">
                        <AppText color="#4d4d4d" textSize="2.6" fontWeight="600" align="center">{institutionData?.name} Inc</AppText>
                        <AppText color="#777777" textSize="2.5" align="center" fontWeight="500"topMargin="3">{institutionData?.address}</AppText>
                    </CustomContainer>
                </GridContainer>
                <GridContainer topMargin="6">
                    <FlexRow justifyContent="space-between" width="90" sizeUnit="%" gap="2" alignItems="center">
                        <CustomContainer width='15.4' height='4'>
                            {institutionData?.logo ? <Icon src={institutionData?.logo} /> : null}
                        </CustomContainer>
                        <FlexRow width="auto" sizeUnit="" gap="3">
                            <AppLink href='#'>
                                <AppSpan color="#0D968F" textSize="3.5">
                                    <AiOutlineInstagram/>
                                </AppSpan>
                            </AppLink>
                            <AppLink href='#'>
                                <AppSpan color="#0D968F" textSize="3" hoverColor="#000000">
                                    <ImFacebook/>
                                </AppSpan>
                            </AppLink>
                            <AppLink href='#'>
                                <AppSpan color="#0D968F" textSize="3.5">
                                    <AiOutlineTwitter/>
                                </AppSpan>
                            </AppLink>
                        </FlexRow>
                    </FlexRow>
                </GridContainer>
            </CustomContainer>
        </div>
    );
});